<template>
  <div id="distribut">
    <div class="breadcrumb">
      分销员管理
      <el-button
        class="right_f"
        type="primary"
        @click="dialogFormVisible = true"
        >新增</el-button
      >
      <!-- <el-button class="right_f" type="primary" @click="testExportExcel">导出</el-button>
            <el-upload :action="actionUrl" :with-credentials="false" name="file" :mutiple="false"
                enctype='multipart/form-data' :on-success="handleSuccess" :on-error="handleError"
                :on-progress="handleProgress">
                <el-button size="small" type="primary">点击上传</el-button>
            </el-upload> -->
    </div>

    <div class="distribut-box">
      <el-table :data="distributList" style="overflow-x: auto">
        <el-table-column prop="index" label="序号" width="80"></el-table-column>
        <el-table-column prop="code" label="渠道ID"></el-table-column>
        <el-table-column prop="userName" label="用户名"></el-table-column>
        <el-table-column prop="school" label="学校"></el-table-column>
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column
          prop="phone"
          label="联系方式"
          width="130"
        ></el-table-column>
        <el-table-column prop="status" label="状态"></el-table-column>
        <el-table-column inline-template label="操作">
          <el-button
            type="text"
            v-if="row.status == '在职'"
            @click="closePower(row)"
            >关闭</el-button
          >
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        v-show="totalCount > 0"
        layout="prev, pager, next, jumper"
        :page-size="pageSize"
        :current-page="pageNum"
        :total="totalCount"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="设置分销员"
      v-model="dialogFormVisible"
      :modal-append-to-body="false"
    >
      <el-form :model="distributInfo">
        <el-form-item label="用户名：" :label-width="formLabelWidth">
          <el-input
            v-model="distributInfo.userName"
            placeholder="请输入用户名，例：ydsjxy001"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系方式：" :label-width="formLabelWidth">
          <el-input
            v-model="distributInfo.phone"
            placeholder="请输入手机号"
            @change="changePhone"
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名：" :label-width="formLabelWidth">
          <el-input
            v-model="distributInfo.name"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="学校：" :label-width="formLabelWidth">
          <el-input
            v-model="distributInfo.school"
            placeholder="请输入学校"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addNewDistributor">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      actionUrl: "",
      pageNum: 1,
      pageSize: 20,
      totalCount: 0,
      distributList: [],
      dialogFormVisible: false,
      formLabelWidth: "160px",
      distributInfo: {
        userName: "",
        name: "",
        school: "",
        phone: "",
      },
    };
  },
  mounted() {
    this.getDistributList();
    this.actionUrl = this.$util.nodeDomain + "/h5/activity/creditCard/import";
  },
  methods: {
    // 获取分销员列表
    getDistributList(num) {
      let url =
        this.$util.nodeDomain + "/h5/activity/creditCard/distribut/list";

      this.distributList = [];

      if (!num) {
        this.pageNum = 1;
      }

      this.$http({
        method: "POST",
        url: url,
        body: JSON.stringify({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }),
      }).then((res) => {
        if (res.data.error == 10000) {
          let preObj = res.data.data;
          if (preObj && preObj.list && preObj.list.length > 0) {
            this.totalCount = preObj.totalCount * 1;
            preObj.list.forEach((item, index) => {
              this.distributList.push({
                ...item,
                index: index + 1,
                status: item.status == 1 ? "在职" : "离职",
              });
            });
          }
        }
      });
    },

    changePhone(value) {
      if (/^1[3456789]\d{9}$/.test(value)) {
        this.distributInfo.password = value.substring(5);
      }
    },

    // 校验输入内容
    checkFormInputValue() {
      let message = "";
      if (!this.distributInfo.school || !this.distributInfo.school.trim()) {
        message = "请输入学校！";
      }
      if (!this.distributInfo.name || !this.distributInfo.name.trim()) {
        message = "请输入姓名！";
      }
      if (!/^1[3456789]\d{9}$/.test(this.distributInfo.phone)) {
        message = "请输入正确的手机号！";
      }
      if (!this.distributInfo.phone || !this.distributInfo.phone.trim()) {
        message = "请输入手机号！";
      }
      if (!this.distributInfo.userName || !this.distributInfo.userName.trim()) {
        message = "请输入用户名！";
      }
      return message;
    },

    // 新增分销员
    addNewDistributor() {
      if (this.checkFormInputValue()) {
        return this.$util.errorMsg(this.checkFormInputValue());
      }
      let url = this.$util.nodeDomain + "/h5/activity/creditCard/distribut/add";

      this.$http({
        method: "POST",
        url: url,
        body: JSON.stringify({
          userName: this.distributInfo.userName.trim(),
          name: this.distributInfo.name.trim(),
          school: this.distributInfo.school.trim(),
          phone: this.distributInfo.phone,
        }),
      })
        .then((res) => {
          if (res.data.error == 10000) {
            this.getDistributList();
            this.dialogFormVisible = false;
            this.$util.successMsg("操作成功");
          } else {
            this.$util.errorMsg(res.data.message);
          }
        })
        .catch((err) => {
          this.$util.errorMsg("操作失败");
        });
    },

    closePower(row) {
      let url =
        this.$util.nodeDomain + "/h5/activity/creditCard/distribut/edit";
      this.$confirm("你确定要关闭该分销员吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http({
          method: "POST",
          url: url,
          body: JSON.stringify({
            id: row.id,
            status: 0,
          }),
        }).then((res) => {
          if (res.data.error == 10000) {
            this.$util.successMsg("操作成功");
            this.getDistributList();
          }
        });
      });
    },

    handleSuccess(response, file) {
      if (response.error === 10000) {
        // 上传成功，更新数据或者展示错误数据
      } else {
        this.$util.errorMsg("上传失败");
      }
    },
    handleError(err, file, fileList) {
      this.$util.errorMsg("上传失败");
    },

    testExportExcel() {
      this.$http({
        method: "GET",
        url: this.$util.nodeDomain + "/h5/activity/creditCard/export",
      }).then((res) => {
        console.log(res);
        if (res && res.data instanceof Blob) {
          // const blob = new Blob([res.data], { type: 'application/application/octet-stream;charset=utf-8' })
          // console.log(blob instanceof Blob)
          const downloadElement = document.createElement("a"); // 创建下载的链接
          const href = window.URL.createObjectURL(res.data);
          downloadElement.href = href;
          downloadElement.download =
            "distribut_" + new Date().format("yyyyMMdd_hhmmss") + ".xlsx"; // 下载后的文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 下载
          document.body.removeChild(downloadElement); // 下载完成 移除 a
          window.URL.revokeObjectURL(href); // 释放blob对象
        }
      });
    },

    handleCurrentChange(val) {
      this.pageNum = val * 1;
      this.getDistributList(val);
    },
  },
};
</script>
<style scoped>
.distribut-box {
  padding: 20px;
}

.el-upload {
  float: right;
  width: 120px;
  margin-right: 30px;
}

.el-button--small {
  padding: 0;
  width: 70px;
  line-height: 36px;
}

.el-input {
  width: 280px;
}
</style>



// WEBPACK FOOTER //
// distribut.vue?321de964